(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function doartUpdateMainHeaderOverlayMetrics() {
    const main =
      document.querySelector(
        '.shopify-section-group-header-group .shopify-section.section-header header.header'
      ) || document.querySelector('.section-header header.header');
    if (!main) return;
    const headerRect = main.getBoundingClientRect();
    const group =
      document.querySelector('.shopify-section-group-header-group') || document.documentElement;
    const ann =
      group.querySelector('.announcement-bar') || document.querySelector('.announcement-bar');
    let topEdge = headerRect.top;
    if (ann) {
      const ar = ann.getBoundingClientRect();
      if (ar.height > 0 && ar.bottom > 0) {
        topEdge = ar.bottom;
      }
    }
    const bottomEdge = headerRect.bottom;
    const height = Math.max(1, Math.round(bottomEdge - topEdge));
    document.documentElement.style.setProperty('--doart-main-header-height', `${height}px`);
    document.documentElement.style.setProperty(
      '--doart-main-header-top',
      `${Math.max(0, topEdge)}px`
    );
  }
  window.doartUpdateMainHeaderOverlayMetrics = doartUpdateMainHeaderOverlayMetrics;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.resizeHandler = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.resizeHandler);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
      doartUpdateMainHeaderOverlayMetrics();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.resizeHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector('.header__icons--search details-modal.header__search--toolbar');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener(
    'toggle',
    function (e) {
      var t = e.target;
      if (!t || !t.closest || t.tagName !== 'DETAILS') return;
      if (!t.closest('details-modal.header__search--toolbar')) return;
      if (t.open) doartUpdateMainHeaderOverlayMetrics();
    },
    true
  );
  window.addEventListener(
    'scroll',
    function () {
      if (document.querySelector('details-modal.header__search--toolbar details[open]')) {
        doartUpdateMainHeaderOverlayMetrics();
      }
    },
    { passive: true }
  );
  document.addEventListener('shopify:section:load', doartUpdateMainHeaderOverlayMetrics);
  requestAnimationFrame(function () {
    doartUpdateMainHeaderOverlayMetrics();
  });

  } catch(e) { console.error(e); }
})();
})();
